import React, { useEffect, useRef } from "react";
import { getEnv } from "@ace/env";

// eslint-disable-next-line @nx/enforce-module-boundaries
import { AgGridReact, AgGridReactProps } from "ag-grid-react";
// eslint-disable-next-line @nx/enforce-module-boundaries
import { LicenseManager } from "ag-grid-enterprise";
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ColDef, colorSchemeDark, themeQuartz } from "ag-grid-community";

import { Theme, useTheme } from "@mui/material";
import { debounce } from "lodash";

const agGridLicense = getEnv("VITE_ACE_WEB_AGGRID_LICENSE");
LicenseManager.setLicenseKey(agGridLicense);

/*
  For additional overrides/alterations and full list of
  variables see: https://www.ag-grid.com/react-data-grid/global-style-customisation-variables/
**/
const agGridQuartzOverrides = (theme: Theme) =>
  ({
    height: "100%",
    width: "100%",
    paddingTop: "5px",
    "--ag-background-color": theme.palette.background.paper,
    "--ag-header-background-color": theme.palette.background.paperTertiary,
    "--ag-font-family": theme.typography.fontFamily,
  } as React.CSSProperties);

export type GridProps = AgGridReactProps & object;

const defaultColDefs: ColDef = {
  suppressHeaderMenuButton: true,
};

export default (props: GridProps) => {
  const theme = useTheme();
  const gridApiRef = useRef<any>(null);
  const darkTheme = themeQuartz.withPart(colorSchemeDark);

  useEffect(() => {
    const handleResize = debounce(() => {
      if (gridApiRef.current) {
        gridApiRef.current.sizeColumnsToFit();
      }
    }, 100);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div style={agGridQuartzOverrides(theme)}>
      <AgGridReact
        theme={darkTheme}
        suppressCsvExport={true}
        onGridReady={(event) => {
          gridApiRef.current = event.api;
          props.onGridReady?.(event);
        }}
        defaultColDef={defaultColDefs}
        {...props}
      />
    </div>
  );
};
